import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-border py-16" role="contentinfo">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-display font-bold text-gradient" aria-label="AdV3nture home">
              AdV3nture
            </Link>
            <p className="text-xs text-muted-foreground mt-3 leading-relaxed">
              Connecting founders and investors through structured discovery. UK registered.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://www.linkedin.com/company/adv3ntureio/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow AdV3nture on LinkedIn"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
          <nav aria-label="Platform pages">
            <h4 className="font-display font-semibold text-sm mb-4">Platform</h4>
            <div className="flex flex-col gap-2">
              <Link to="/how-it-works" className="text-sm text-muted-foreground hover:text-foreground transition-colors">How It Works</Link>
              <Link to="/for-founders" className="text-sm text-muted-foreground hover:text-foreground transition-colors">For Founders</Link>
              <Link to="/for-investors" className="text-sm text-muted-foreground hover:text-foreground transition-colors">For Investors</Link>
              <Link to="/fundraising-statistics" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Fundraising Statistics</Link>
              <Link to="/security" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Security</Link>
            </div>
          </nav>
          <nav aria-label="Company pages">
            <h4 className="font-display font-semibold text-sm mb-4">Company</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">About</Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact</Link>
              <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Blog</Link>
              <Link to="/help" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Help Center</Link>
            </div>
          </nav>
          <nav aria-label="Legal pages">
            <h4 className="font-display font-semibold text-sm mb-4">Legal</h4>
            <div className="flex flex-col gap-2">
              <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Terms & Conditions</Link>
              <Link to="/cookies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Cookie Policy</Link>
            </div>
          </nav>
        </div>
        <div className="border-t border-border pt-8 text-center">
          <p className="text-xs text-muted-foreground">
            © 2026 adv3nture. All rights reserved. Registered in England & Wales.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
